import { FC } from 'react';
import { Tooltip } from 'antd';
import { StatusTagSize, StyledStatus, StyledStatusTag } from './StatusTag.styles';

const StatusTag: FC<{
    color: string;
    status: string;
    dataTestId?: string;
    size?: StatusTagSize;
    hideText?: boolean;
}> = ({ color, status, dataTestId, size = 'large', hideText = false }) => {
    return (
        <StyledStatus data-testid={dataTestId}>
            <Tooltip title={hideText ? status : undefined}>
                <StyledStatusTag color={color} $size={size} />
            </Tooltip>
            {!hideText && (
                <span
                    style={{
                        whiteSpace: 'normal',
                        overflowWrap: 'break-word',
                        wordWrap: 'break-word',
                    }}
                >
                    {status}
                </span>
            )}
        </StyledStatus>
    );
};

export default StatusTag;
